import axios from "@/utils/axios.js";

/**
 * 根据楼盘ID查找对应的置业顾问列表
 * @param {string} id 楼盘ID
 */
export async function getSaleAdvisor(id) {
  // /customReport/getSaleAdvister/
  return axios.post(`/customReport/getSaleAdvister/${encodeURIComponent(id)}`);
}
